import React, { useCallback /*, useEffect, useContext*/ } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import IconButton from '@material-ui/core/IconButton';
// import CloseIcon from '@material-ui/icons/Close';
// import SimpleBar from 'simplebar-react';

// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdButton from './AfitdButton';

// import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _noop from 'lodash/noop';

const styles = theme => ({
    root: {},
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '600',
    },
    contentText: {
        color: '#111E14',
        fontSize: '1rem',
        fontWeight: 400,
    },
    title: {
        '& >*': {
            fontWeight: 'bold',
        },
    },
    // paperScrollPaper: {
    //     // overflowY: 'auto', //'visible', //'hidden',
    // },
    // content: {
    //     // overflowY: 'hidden', //'visible',
    //     '&::-webkit-scrollbar-track': {
    //         // '-webkit-box-shadow': 'inset 0 0 1px rgba(0,0,0,0.1)',
    //         borderRadius: '10px',
    //         background: 'none',
    //     },
    //     '&::-webkit-scrollbar': {
    //         width: '8px',
    //         backgroundColor: '#F5F5F5',
    //     },
    //     '&::-webkit-scrollbar-thumb': {
    //         // '-webkit-box-shadow': 'inset 0 0 1px rgba(0,0,0,0.1)',
    //         borderRadius: '10px',
    //         backgroundColor: 'rgba(0,0,0,0.2)',
    //     },
    // },
    // actionContainer: {
    //     display: 'flex',
    //     justifyContent: 'space-between',
    //     width: '640px',
    //     padding: '0 16px 16px 16px',
    // },
    // rightActionContainer: {
    //     display: 'flex',
    //     justifyContent: 'flex-end',
    //     flexGrow: '2',
    // },
});

const getDefns = params => {
    const { props, handleClickOkButton } = params;
    const { classes, okButtonColor, maxWidth } = props;

    const defns = {
        root: {
            maxWidth: maxWidth ?? 'md',
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
        },
        okButton: {
            color: okButtonColor ?? 'primary',
            onClick: handleClickOkButton,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const AfitdMessageDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { classes, title = '', message, children, onClose, noActions, ...otherProps } = props;
    const { paperScrollPaper: paperScrollPaperCls, content: contentCls } = classes;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    const handleClickOkButton = useCallback(() => {
        onClose();
    }, [onClose]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props, handleClickOkButton });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <Dialog {...defns.root} {...otherProps} classes={{ paperScrollPaper: paperScrollPaperCls }}>
            <DialogTitle {...defns.title}>{title} </DialogTitle>
            <DialogContent className={contentCls}>
                <DialogContentText
                    id="alert-dialog-description"
                    classes={{
                        root: classes.contentText,
                    }}
                >
                    {children || message}
                </DialogContentText>
            </DialogContent>
            {!noActions && (
                <DialogActions>
                    <div {...defns.actionContainer}>
                        <div {...defns.rightActionContainer}>
                            <AfitdButton {...defns.okButton}>OK</AfitdButton>
                        </div>
                    </div>
                </DialogActions>
            )}
        </Dialog>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(AfitdMessageDialog);
